export enum LibraryToolbarDrawerContentType {
  Default,
  NewWord,
  ReplacementSelected,
  WordSelected,
  NewReplacement,
}

export default { LibraryToolbarDrawerContentType };
